import React from 'react';

export default function Select({ className = '', children, ...props }) {
    return (
        <select
            {...props}
            className={
                'py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-main-color focus:ring-main-color disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 ' +
                className
            }
        >
            {children}
        </select>
    );
}
